import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.2}
    stroke="currentColor"
    className="w-3.5 h-3.5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 4.5 3 12m0 0 7.5 7.5M3 12h18"
    />
  </svg>
);

const DoctorsListSection = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const res = await axios.get(
          "https://medizenapi.ir/v1/doctor/getDoctors?page=1&count=8",
        );

        if (res.data?.response_status === "success") {
          setDoctors(res.data.data || []);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center">
        <div
          className="w-10 h-10 rounded-full border-4 
        border-purple border-t-transparent animate-spin"
        />
      </div>
    );
  }

  return (
    <section className="">
      {/* Header */}

      <div className="flex items-center justify-between mb-5">
        <h3 className="flex items-center gap-2 w-[70%] lg:w-[50%] font-semibold text-[#383838]">
          <span className="flex items-center whitespace-nowrap text-[17px] md:text-[22px]">
            <span className="text-[#383838] ml-1.5">جدیدترین پزشکان</span>
          </span>
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent" />
        </h3>

        <Link
          to="/doctors"
          className="
          flex
          items-center
          gap-1.5
          text-purple
          text-[12px]
          font-medium
          hover:gap-3
          transition-all
          "
        >
          مشاهده همه
          <ArrowIcon />
        </Link>
      </div>

      <div
        className="
    grid
    grid-cols-1
    sm:grid-cols-2
    lg:grid-cols-3
    xl:grid-cols-4
    gap-y-3
    gap-x-3
  "
      >
        {doctors.map((doctor, index) => (
          <div
            key={doctor.id}
            onClick={() => navigate(`/doctor/${doctor.id}`)}
            className={`
              group
              relative
              cursor-pointer
              transition-all
              duration-300
              hover:bg-[#F8FEFE]
              rounded-2xl
              border
            `}
          >
            <div className="flex items-center gap-2 py-2 md:py-3 px-2 md:px-3">
              {/* Avatar */}
              <div className="relative shrink-0">
                <img
                  src={`https://bit.medizen.ir/i/${doctor.thumb}`}
                  alt={doctor.name}
                  className="
                    w-[58px]
                    h-[58px]
                    rounded-2xl
                    object-cover
                    border
                    border-gray-100
                    transition-transform
                    duration-300
                    group-hover:scale-105
                  "
                />

                {doctor.activity_status === "active" && (
                  <span
                    className="
                      absolute
                      bottom-0
                      right-0
                      w-3.5
                      h-3.5
                      rounded-full
                      border-[2px]
                      border-white
                      bg-[#22C55E]
                    "
                  />
                )}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3
                    className="
                      text-[13px]
                      lg:text-[14px]
                      font-semibold
                      text-[#242424]
                      truncate
                    "
                  >
                    {doctor.name}
                  </h3>

                  {doctor.score && (
                    <div
                      className="
                        hidden
                        sm:flex
                        items-center
                        gap-0.5
                        px-1
                        py-[3px]
                        text-[11px]
                      "
                    >
                      ⭐
                      <span
                        className="
                          text-[12px]
                          font-bold
                          text-[#B98500]
                        "
                      >
                        {doctor.score}
                      </span>
                    </div>
                  )}
                </div>

                <p
                  className="
                    mt-1
                    text-[11px]
                    text-gray-500
                    truncate
                  "
                >
                  {doctor.title}
                </p>
              </div>

              {/* Right */}
              <div
                className="
                  flex
                  items-center
                  gap-2
                  text-[#49D1CD]
                  font-semibold
                  text-[13px]
                  shrink-0
                "
              >
                <div
                  className="
                    w-7
                    h-7
                    p-2
                    rounded-lg
                    bg-[#49D1CD]/10
                    flex
                    items-center
                    justify-center
                    transition-all
                    duration-300
                    group-hover:bg-[#49D1CD]
                    group-hover:text-white
                  "
                >
                  <ArrowIcon />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DoctorsListSection;
